// digests.ts — Patch 015.17 (Digest UI).
//
// Backend: workers/core-os/src/routes/digests.ts (weekly_digests migration
// 0037; the 015.17 compose route added the Gmail-draft surface).

import { request } from './request'

const pid = (id: string): string => encodeURIComponent(id)

export type DigestStatus =
  | 'draft'
  | 'reviewed'
  | 'sent'
  | 'sent_with_edits'
  | 'skipped'

export interface DigestRow {
  id: string
  project_id: string
  digest_week_start: string
  digest_week_end: string
  body_text: string
  body_format: string
  photo_document_ids: string | null
  status: DigestStatus
  gmail_draft_id: string | null
  sent_at: string | null
  reviewed_at: string | null
  prompt_version: string | null
  cost_estimate_usd: number | null
  created_at: string
  updated_at: string | null
}

export const digestsApi = {
  list: (projectId: string, status?: DigestStatus) =>
    request<{ ok: true; digests: DigestRow[]; count: number }>(
      `/api/projects/${pid(projectId)}/digests${status ? `?status=${status}` : ''}`,
    ),
  get: (projectId: string, digestId: string) =>
    request<{ ok: true; digest: DigestRow }>(
      `/api/projects/${pid(projectId)}/digests/${pid(digestId)}`,
    ),
  generate: (projectId: string, weekStart: string, weekEnd: string) =>
    request<{ ok: boolean; id?: string; status?: string; error?: string }>(
      `/api/projects/${pid(projectId)}/digests/generate`,
      {
        method: 'POST',
        body: JSON.stringify({ week_start: weekStart, week_end: weekEnd }),
      },
    ),
  update: (
    projectId: string,
    digestId: string,
    body: { body_text?: string; status?: DigestStatus },
  ) =>
    request<{ ok: true; id: string; updated: string[] }>(
      `/api/projects/${pid(projectId)}/digests/${pid(digestId)}`,
      { method: 'PATCH', body: JSON.stringify(body) },
    ),
  compose: (projectId: string, digestId: string) =>
    request<{
      ok: true
      digest_id: string
      gmail_draft_id: string
      gmail_draft_url: string
    }>(`/api/projects/${pid(projectId)}/digests/${pid(digestId)}/compose`, {
      method: 'POST',
      body: '{}',
    }),
}
